angular.module('mailService', ['constants'])
.factory('mailService', function($http, $q, myConfig) {

  var service = {};

  var _baseUrl = myConfig.apiUrl + 'rings/'; //'http://127.0.0.1:8000/v1/rings/';

  // request ringing data
  service.sendEmail = function(data){
    var tableName = 'send_mail_generic';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method: 'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  return service;

});
